import api from "./axios";

export const getServerStats = () => api.get("/server/stats");
